﻿import 'regenerator-runtime/runtime'; // Enable js async/await with parcel and babel.

async function init() {
    await import('./site-vue');
    await import('./site-app');
}

init();